// extracted by mini-css-extract-plugin
module.exports = {"root":"_17UHP","visible":"_2Vz04","overlay":"_1I3y4","fixed":"YFJpV","content":"_1zy-k","center":"_3m60B"};